import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

import Checkbox from './shared/Checkbox.vue';
import TextInput from './shared/TextInput.vue';

Vue.config.productionTip = false;

Vue.component('checkbox', Checkbox)
Vue.component('text-input', TextInput)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
